import React, { useContext } from 'react';
import { Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';

import ModalsContext from 'src/context/modals.jsx';

const PinsTable = ({ fields, remove, update, era_id }) => {
	if (!fields?.length) return <></>;

	const modals_context = useContext(ModalsContext);

	const get_type_display = (type) => {
		switch (type) {
			case 'plus':
				return 'Plus';
			case 'star':
				return 'Star';
			case 'crossroads':
				return 'Crossroads';
			default:
				return type;
		}
	};

	const get_content_preview = (content) => {
		if (!content || !content.length) return 'No content';
		
		const preview = content
			.map((item) => {
				switch (item.type) {
					case 'img':
						return '<Image>';
					case 'header':
					case 'text':
						return item.data.replace(/<[^>]*>/g, '');
					case 'line_break':
						return '<Line Break>';
					default:
						return '';
				}
			})
			.filter((part) => part)
			.join(' ');
		
		if (!preview) return 'No content';
		
		return preview.length > 100 ? preview.substring(0, 100) + '...' : preview;
	};

	return (
		<Grid item xs={12}>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ pl: 3 }}>UID</TableCell>
							<TableCell align="left">Coordinates</TableCell>
							<TableCell align="left">Type</TableCell>
							<TableCell align="left">Position</TableCell>
							<TableCell align="left">Content Preview</TableCell>
							<TableCell align="left" sx={{ pr: 3 }}>
								Actions
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{fields.map((pin, index) => (
							<TableRow key={index}>
								<TableCell sx={{ pl: 3 }}>
									<Typography align="left" variant="subtitle1">
										{pin.uid || '-'}
									</Typography>
								</TableCell>
								<TableCell>
									<Typography align="left" variant="subtitle1">
										{pin.x !== undefined && pin.y !== undefined ? `X: ${pin.x}% Y: ${pin.y}%` : 'Not set'}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{get_type_display(pin.type)}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{pin.position || '-'}
									</Typography>
								</TableCell>

								<TableCell>
									<Typography align="left" variant="subtitle1">
										{get_content_preview(pin.content)}
									</Typography>
								</TableCell>

								<TableCell sx={{ pr: 1 }} align="right">
									<Stack direction="row">
										<IconButton
											color="error"
											size="small"
											onClick={() =>
												modals_context.show('pin_delete', {
													clb: () => remove(index),
												})
											}
										>
											<DeleteTwoToneIcon fontSize="small" />
										</IconButton>
										<IconButton
											color="secondary"
											size="large"
											onClick={() =>
												modals_context.show('pin_edit', {
													data: pin,
													era_id: era_id,
													clb: (data) => update(index, data),
												})
											}
										>
											<EditTwoToneIcon sx={{ fontSize: '1.3rem' }} />
										</IconButton>
									</Stack>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Grid>
	);
};

export default PinsTable;

